import React from "react";
import { withStyles } from "@material-ui/core/styles";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import Dialog from "@material-ui/core/Dialog";
import { withSnackbar } from "notistack";
import DialogContent from "@material-ui/core/DialogContent";
import { DialogTitle, Grid } from "@material-ui/core";
import EquipmentDefects from "./Grid/index";
import styles from "./styles";
import { compose } from "recompose";
import { getDataWithQueryString } from "../../../../../../api/componentAPIs";
import MESSAGES from "../../../../../../appMessages";
import { EQUIPMENT_DEFECTS_GRID_FILTER } from "./constants";
import { SearchBar, CustomDropdown } from "./Grid/components";
import Events from "../../../../../../utilities/EventEmitter";
import { getMappedDefectData, getFilterPreviousDefectData } from "./utils";
import appConstants from "../../../../../../appConstants";
import ClearAllFilterButton from "../../../../../dataGrid/columnFilters/ClearAllFilterButton";

class TrailerDefectDialog extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      trailerDefect: [],
      tractorDefect: [],
      dollyDefect: [],
      quickFilterText: "",
      selectedEquipmentType: null,
      showLoader: true,
      gridErrorMessage: "loading",
    };
    this.equipmentTypeOptions = [];
    this.gridApi = {};
  }

  componentDidMount() {
    this.getEquipmentDefectsAPIData();
    this.setEquipmentTypeOptions();
    Events.on("EquipmentDefectsUpdated", this.updateEquipmentDefectData);
  }

  componentWillUnmount() {
    Events.removeListener(
      "EquipmentDefectsUpdated",
      this.updateEquipmentDefectData,
    );
  }

  onGridReady = ({ api }) => {
    this.gridApi = api;
  };

  updateEquipmentDefectData = (data) => {
    const { trailer, tractor, dolly } = data;
    let [
      updatedTrailerDefectList,
      updatedTractorDefectList,
      updatedDollyDefectList,
    ] = [[], [], []];
    if (trailer && trailer.defects?.length !== 0) {
      updatedTrailerDefectList = getMappedDefectData(
        [trailer],
        "trailerNumber",
      );
    }
    if (tractor && tractor.defects?.length !== 0) {
      updatedTractorDefectList = getMappedDefectData(
        [tractor],
        "tractorNumber",
      );
    }
    if (dolly && dolly.defects?.length !== 0) {
      updatedDollyDefectList = getMappedDefectData([dolly], "dollyNumber");
    }
    this.updateEventsDefectDataInState({
      updatedTrailerDefectList,
      updatedTractorDefectList,
      updatedDollyDefectList,
    });
  };

  updateEventsDefectDataInState = (defectData) => {
    const { trailerDefect, tractorDefect, dollyDefect } = this.state;
    const { newTrailerDefectList, newTractorDefectList, newDollyDefectList } =
      getFilterPreviousDefectData({
        defectData,
        trailerDefect,
        tractorDefect,
        dollyDefect,
      });
    this.setState({
      trailerDefect: newTrailerDefectList,
      tractorDefect: newTractorDefectList,
      dollyDefect: newDollyDefectList,
    });
  };

  getEquipmentDefectsAPIData = () => {
    const terminalCode = this.props.userProfile.terminal.code;
    getDataWithQueryString(
      "GetAllEquipment",
      `terminalCode=${terminalCode}&onlyDefects=true`,
    ).then((res) => {
      if (res.status === 200) {
        const { trailer, tractor, dolly } = res.data;
        this.setState({
          trailerDefect: getMappedDefectData(trailer, "trailerNumber"),
          tractorDefect: getMappedDefectData(tractor, "tractorNumber"),
          dollyDefect: getMappedDefectData(dolly, "dollyNumber"),
          showLoader: false,
          gridErrorMessage: appConstants.GRID_STATUS.SUCCESS,
        });
      } else {
        this.handleError();
      }
    });
  };

  updateQuickFilterText = (event) => {
    this.setState({
      quickFilterText: event.target.value,
    });
  };

  handleError = () => {
    this.props.enqueueSnackbar(MESSAGES.COMMON.LOADING_DATA, {
      variant: "error",
    });
    this.setState({
      showLoader: false,
      gridErrorMessage: appConstants.GRID_STATUS.ERROR,
      trailerDefect: [],
      tractorDefect: [],
      dollyDefect: [],
    });
  };

  getEquipmentDefectsData = () => {
    const { selectedEquipmentType } = this.state;
    if (!selectedEquipmentType?.value) {
      return;
    }
    if (selectedEquipmentType.value === EQUIPMENT_DEFECTS_GRID_FILTER.trailer) {
      return this.state.trailerDefect;
    } else if (
      selectedEquipmentType.value === EQUIPMENT_DEFECTS_GRID_FILTER.tractor
    ) {
      return this.state.tractorDefect;
    } else {
      return this.state.dollyDefect;
    }
  };

  onClose = () => {
    this.props.onCancel();
  };

  setEquipmentTypeOptions = () => {
    this.equipmentTypeOptions = Object.values(
      EQUIPMENT_DEFECTS_GRID_FILTER,
    ).map((equipmentType) => ({
      label: equipmentType?.toUpperCase(),
      value: equipmentType,
    }));
    const selectedEquipmentType = this.props.defaultEquipmentType
      ? {
          label: this.props.defaultEquipmentType.toUpperCase(),
          value: this.props.defaultEquipmentType,
        }
      : this.equipmentTypeOptions[0];
    this.setState({
      selectedEquipmentType,
    });
  };

  handleEquipmentTypeChange = (equipmentType) => {
    this.setState({
      selectedEquipmentType: equipmentType,
    });
  };

  render() {
    const { classes } = this.props;
    const { theme } = this.props.userProfile || {};
    const {
      showLoader,
      quickFilterText,
      selectedEquipmentType,
      gridErrorMessage,
    } = this.state;
    const disableSectionClass = showLoader ? classes.disableSection : null;
    return (
      <React.Fragment>
        <Dialog
          aria-labelledby="trailer-defect"
          open={true}
          classes={{ paper: classes.dialog }}
          className={`${classes.dialogWrapper} ${
            theme === "dark" ? "darkTheme" : "lightTheme"
          } `}
        >
          <DialogTitle
            disableTypography
            handleClose={this.onClose}
            id="trailer-defect"
            classes={{ root: classes.dialogTitle }}
          >
            <Grid xs={3}>
              <span className={classes.dialogTitleText}>
                E-DVIR Information
              </span>
            </Grid>
            <Grid xs={3} className={disableSectionClass}>
              <CustomDropdown
                autoFocus={true}
                value={
                  selectedEquipmentType?.value
                }
                options={this.equipmentTypeOptions}
                onChange={this.handleEquipmentTypeChange}
              />
            </Grid>
            <Grid xs={5} className={disableSectionClass}>
              <SearchBar updateQuickFilterText={this.updateQuickFilterText} />
              <ClearAllFilterButton gridApi={this.gridApi} />
            </Grid>
            <Grid xs={1} className={classes.closeButton}>
              <IconButton aria-label="close" onClick={this.onClose}>
                <CloseIcon />
              </IconButton>
            </Grid>
          </DialogTitle>
          <DialogContent className={classes.dialogContent}>
            <EquipmentDefects
              equipmentDefectsData={this.getEquipmentDefectsData()}
              quickFilterText={quickFilterText}
              gridErrorMessage= {gridErrorMessage}
              showLoader={this.state.showLoader}
              onGridReady={this.onGridReady}
              gridApi={this.gridApi}
            />
          </DialogContent>
        </Dialog>
      </React.Fragment>
    );
  }
}

export default compose(withSnackbar, withStyles(styles))(TrailerDefectDialog);
